import classNames from 'classnames';
import { forwardRef } from 'react';
const buttonWrapperCss = "b6bllgc";
export const ButtonWrapper = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(buttonWrapperCss, props.className)} />);
const horizontalFieldsWrapperCss = "h1iyg3cl";
export const HorizontalFieldsWrapper = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(horizontalFieldsWrapperCss, props.className)} />);
const horizontalFieldCss = "h1q38v3s";
export const HorizontalField = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(horizontalFieldCss, props.className)} />);
const aussieTextCss = "a7fs0tp";
export const AussieText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(aussieTextCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");